import React from "react";
import Svg, { Path } from "react-native-svg";

const Warning = (props) => {
  const { color = "#fff", height = 14, width = 14 } = props;

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <Path
        d="M13.65 10.051L8.724 1c-.79-1.332-2.72-1.334-3.511 0L.29 10.05c-.809 1.36.17 3.084 1.755 3.084h9.848c1.584 0 2.565-1.722 1.756-3.084zm-6.68 1.45a.818.818 0 010-1.633.818.818 0 010 1.634zm.816-3.266a.818.818 0 01-1.633 0V4.15a.818.818 0 011.633 0v4.084z"
        fill={color}
      />
    </Svg>
  );
};

export default Warning;
